import { render, staticRenderFns } from "./sidebar_vue.vue?vue&type=template&id=25846b80&"
import script from "./sidebar_vue.vue?vue&type=script&lang=js&"
export * from "./sidebar_vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25846b80')) {
      api.createRecord('25846b80', component.options)
    } else {
      api.reload('25846b80', component.options)
    }
    module.hot.accept("./sidebar_vue.vue?vue&type=template&id=25846b80&", function () {
      api.rerender('25846b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/sidebar_vue.vue"
export default component.exports